import React, { Component } from 'react';
import {Link} from "@reach/router";

class HomeBanner extends Component{
  render(){
    return(
      <>
      <div className="home-banner">
        <Link to={this.props.url}><img src={this.props.data.image} /></Link>
      </div>
      </>
    );
  }
}

export default HomeBanner;
